import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { services } from "../../data/services";

const ServicesSection = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("sitevitrine");
    const sectionRef = useRef(null);
    const [isMouseInside, setIsMouseInside] = useState(false);
    const mousePosition = useRef({ x: 0, y: 0 });
    const tabsRef = useRef({});
    const [slidePosition, setSlidePosition] = useState({
        left: 0,
        width: 0,
        top: 0,
        height: 0,
    });

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const mobileTabsContainerRef = useRef({});

    const getServiceFromUrl = () => {
        const search =
            location.search || window.location.hash.split("?")[1] || "";
        const params = new URLSearchParams(search);
        return params.get("service");
    };

    useEffect(() => {
        const serviceFromUrl = getServiceFromUrl();
        if (serviceFromUrl && services.some((s) => s.id === serviceFromUrl)) {
            setActiveTab(serviceFromUrl);
        }
    }, []);

    useEffect(() => {
        const handleServiceSelected = (event) => {
            const { serviceId } = event.detail;
            if (serviceId && services.some((s) => s.id === serviceId)) {
                setActiveTab(serviceId);
            }
        };

        window.addEventListener("serviceSelected", handleServiceSelected);
        return () => {
            window.removeEventListener(
                "serviceSelected",
                handleServiceSelected
            );
        };
    }, []);

    useEffect(() => {
        const serviceFromUrl = getServiceFromUrl();
        if (serviceFromUrl && services.some((s) => s.id === serviceFromUrl)) {
            setActiveTab(serviceFromUrl);
        }
    }, [location]);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!sectionRef.current) return;

            const floatingElements =
                sectionRef.current.querySelectorAll(".floating-element");
            const { clientX, clientY } = e;
            const { width, height, left, top } =
                sectionRef.current.getBoundingClientRect();

            mousePosition.current = {
                x: (clientX - left) / width,
                y: (clientY - top) / height,
            };

            floatingElements.forEach((el, index) => {
                const factor = (index + 1) * 0.03;
                const x = (mousePosition.current.x - 0.5) * factor * 50;
                const y = (mousePosition.current.y - 0.5) * factor * 50;

                el.style.transform = `translate(${x}px, ${y}px)`;
            });
        };

        const handleMouseEnter = () => setIsMouseInside(true);
        const handleMouseLeave = () => setIsMouseInside(false);

        if (sectionRef.current) {
            sectionRef.current.addEventListener("mousemove", handleMouseMove);
            sectionRef.current.addEventListener("mouseenter", handleMouseEnter);
            sectionRef.current.addEventListener("mouseleave", handleMouseLeave);
        }

        return () => {
            if (sectionRef.current) {
                sectionRef.current.removeEventListener(
                    "mousemove",
                    handleMouseMove
                );
                sectionRef.current.removeEventListener(
                    "mouseenter",
                    handleMouseEnter
                );
                sectionRef.current.removeEventListener(
                    "mouseleave",
                    handleMouseLeave
                );
            }
        };
    }, []);

    useEffect(() => {
        console.log(tabsRef);
        console.log(activeTab);
        if (tabsRef.current[activeTab]) {
            const activeButton = tabsRef.current[activeTab];
            const rect = activeButton.getBoundingClientRect();
            const parentRect =
                activeButton.parentElement.getBoundingClientRect();

            setSlidePosition({
                left: rect.left - parentRect.left,
                width: rect.width,
                top: rect.top - parentRect.top,
                height: rect.height,
            });
        }
    }, [activeTab]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (isMobile && mobileTabsContainerRef.current[activeTab]) {
            const activeButton = mobileTabsContainerRef.current[activeTab];
            const rect = activeButton.getBoundingClientRect();
            const parentRect =
                activeButton.parentElement.getBoundingClientRect();

            setSlidePosition({
                left: rect.left - parentRect.left,
                width: rect.width,
                top: rect.top - parentRect.top,
                height: rect.height,
            });
        }
    }, [activeTab, isMobile]);

    const activeService = services.find((s) => s.id === activeTab);

    const tabContainerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.05,
                delayChildren: 0.1,
            },
        },
    };

    const tabVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { type: "spring", stiffness: 300, damping: 24 },
        },
        tap: { scale: 0.97, transition: { duration: 0.1 } },
    };

    const slideVariants = {
        initial: {
            width: 0,
            x: 0,
            opacity: 0,
        },
        animate: {
            width: slidePosition.width,
            x: slidePosition.left,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 400,
                damping: 30,
            },
        },
    };

    // const showcaseVariants = {
    //     initial: {
    //         opacity: 0,
    //         y: 15,
    //         transition: {
    //             duration: 0.2,
    //             ease: "easeIn",
    //         },
    //     },
    //     animate: {
    //         opacity: 1,
    //         y: 0,
    //         transition: {
    //             duration: 0.3,
    //             ease: "easeOut",
    //         },
    //     },
    //     exit: {
    //         opacity: 0,
    //         y: -15,
    //         transition: {
    //             duration: 0.2,
    //             ease: "easeIn",
    //         },
    //     },
    // };

    const showcaseVariants = {
        initial: {
            y: 15,
            transition: {
                duration: 0.2,
                ease: "easeIn",
            },
        },
        animate: {
            y: 0,
            transition: {
                duration: 0.3,
                ease: "easeOut",
            },
        },
        exit: {
            y: -15,
            transition: {
                duration: 0.2,
                ease: "easeIn",
            },
        },
    };

    return (
        <section
            id="services"
            className="pb-20 pt-5 relative overflow-hidden bg-gradient-to-b"
            ref={sectionRef}
        >
            
            <div className="absolute top-10 right-[10%] w-80 h-80 rounded-full bg-blue-300/10 blur-3xl floating-element"></div>
            <div className="absolute bottom-40 left-[5%] w-96 h-96 rounded-full bg-purple-300/10 blur-3xl floating-element"></div>
            <div className="absolute inset-0 opacity-5">
                <svg
                    width="100%"
                    height="100%"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <pattern
                            id="grid"
                            width="40"
                            height="40"
                            patternUnits="userSpaceOnUse"
                        >
                            <path
                                d="M 40 0 L 0 0 0 40"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="0.5"
                            />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#grid)" />
                </svg>
            </div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="flex mx-auto justify-center items-center">
                    <div className="mb-16 max-w-2xl text-center">
                        {/* <div className="mb-6 mt-4">
                            <motion.span
                                className="bg-black/80 text-white text-xs md:text-sm px-6 py-2.5 uppercase tracking-wider font-medium shadow-lg rounded-md"
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1 }}
                            >
                                NOS SERVICES
                            </motion.span>
                        </div> */}
                        <div>
                            <motion.h2
                                className="text-4xl md:text-5xl font-bold text-center title"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.2 }}
                            >
                                Des{" "}
                                <span className="text-gradient">services</span>{" "}
                                sur mesure pour votre création digitale
                            </motion.h2>
                        </div>
                    </div>
                </div>

                <motion.div
                    className="flex justify-center mb-16 overflow-x-auto pb-4"
                    variants={tabContainerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {/* Desktop Tabs - visible uniquement sur desktop */}
                    <div className="hidden md:inline-flex p-1.5 bg-secondary-500/5 backdrop-blur-sm rounded-full relative">
                        {/* Le slider de fond avec dégradé */}
                        <motion.div
                            className={`absolute rounded-full shadow-md z-10 bg-gradient-to-r ${
                                activeService
                                    ? `${activeService.gradientColors}`
                                    : ""
                            }`}
                            style={{
                                height: slidePosition.height,
                            }}
                            initial="initial"
                            animate="animate"
                            variants={slideVariants}
                        />

                        {services.map((service, idx) => (
                            <motion.button
                                key={service.id}
                                ref={(el) => (tabsRef.current[service.id] = el)}
                                onClick={() => {
                                    setActiveTab(service.id);
                                    window.history.pushState(
                                        {},
                                        "",
                                        `/#services?service=${service.id}`
                                    );
                                }}
                                className={`relative px-6 py-3.5 rounded-full font-medium text-sm focus:outline-none z-20
                                  ${
                                      activeTab === service.id
                                          ? "text-white"
                                          : "text-gray-700 hover:text-gray-900"
                                  }
                                `}
                                variants={tabVariants}
                                whileTap="tap"
                            >
                                <div className="flex items-center space-x-2">
                                    <span
                                        className={`transition-transform duration-300 ${
                                            activeTab === service.id
                                                ? "scale-110"
                                                : "hover:scale-110"
                                        }`}
                                    >
                                        {service.icon}
                                    </span>
                                    <span>{service.title.split(" ")[0]}</span>
                                </div>
                            </motion.button>
                        ))}
                    </div>

                    {/* Mobile Tabs - design en grille 3x2 */}
                    <div className="md:hidden w-full px-1">
                        <div className="grid grid-cols-3 gap-2">
                            {services.map((service, idx) => (
                                <motion.button
                                    key={service.id}
                                    ref={(el) =>
                                        (mobileTabsContainerRef.current[
                                            service.id
                                        ] = el)
                                    }
                                    onClick={() => {
                                        setActiveTab(service.id);
                                        window.history.pushState(
                                            {},
                                            "",
                                            `/#services?service=${service.id}`
                                        );
                                    }}
                                    className={`relative flex flex-col items-center justify-center py-3 px-1 rounded-lg focus:outline-none transition-all bg-gradient-to-br shadow-md
                                      ${
                                          activeTab === service.id
                                              ? "text-white transform scale-105 "
                                              : "bg-white/80 text-gray-700 "
                                      }${
                                        activeTab === service.id
                                            ? `${activeService.gradientColors}`
                                            : ""
                                    }
                                    `}
                                    variants={tabVariants}
                                    whileTap="tap"
                                >
                                    <div className="flex items-center space-x-2">
                                        <span
                                            className={`text-xl mb-1 ${
                                                activeTab === service.id
                                                    ? ""
                                                    : "text-gradient"
                                            }`}
                                        >
                                            {service.icon}
                                        </span>
                                        <span className="text-[9px] font-bold">
                                            {service.shortTitle ||
                                                service.title.split(" ")[0]}
                                        </span>
                                    </div>
                                </motion.button>
                            ))}
                        </div>
                    </div>
                </motion.div>

                <div className="max-w-6xl mx-auto">
                    <motion.div
                        key={activeTab}
                        className="grid md:grid-cols-2 rounded-2xl overflow-hidden shadow-xl relative"
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        variants={showcaseVariants}
                        custom={activeTab === "fullstack" ? "left" : "right"}
                    >
                        <div
                            className={`p-4 md:p-10 flex flex-col justify-between relative overflow-hidden bg-gradient-to-br ${
                                activeService
                                    ? `${activeService.gradientColors}`
                                    : ""
                            }`}
                        >
                            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
                                <motion.div
                                    className="absolute top-10 right-10 w-40 h-40 border-2 border-white rounded-full"
                                    animate={{
                                        scale: [1, 1.1, 1],
                                        opacity: [0.8, 1, 0.8],
                                    }}
                                    transition={{
                                        duration: 8,
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                    }}
                                ></motion.div>
                                <motion.div
                                    className="absolute bottom-20 left-10 w-20 h-20 border border-white rounded-full"
                                    animate={{
                                        scale: [1, 1.2, 1],
                                        opacity: [0.7, 1, 0.7],
                                    }}
                                    transition={{
                                        duration: 6,
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                        delay: 1,
                                    }}
                                ></motion.div>
                                <motion.div
                                    className="absolute top-1/3 left-1/3 w-60 h-60 border-4 border-dashed border-white rounded-full"
                                    animate={{ rotate: 360 }}
                                    transition={{
                                        duration: 120,
                                        repeat: Infinity,
                                        ease: "linear",
                                    }}
                                ></motion.div>
                            </div>

                            <div>
                                <motion.div
                                    className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl p-4 mb-4 flex items-center justify-center"
                                    initial={{ rotate: -5, y: -20, opacity: 0 }}
                                    animate={{ rotate: 0, y: 0, opacity: 1 }}
                                    transition={{
                                        type: "spring",
                                        delay: 0.2,
                                        stiffness: 200,
                                    }}
                                >
                                    <div className="text-white w-full h-full">
                                        {activeService.iconBg}
                                    </div>
                                </motion.div>

                                <motion.h3
                                    className="text-3xl md:text-5xl font-bold text-white mb-6"
                                    initial={{ x: -40, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    transition={{ delay: 0.3 }}
                                >
                                    {activeService.title}
                                </motion.h3>

                                <motion.p
                                    className="text-white/90 text-lg mb-2"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.4 }}
                                >
                                    {activeService.description}
                                </motion.p>
                            </div>

                            <motion.div
                                initial={{ y: 30, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: 0.5 }}
                            >
                                <Link
                                    to={`/contact?service=${activeService.id}`}
                                >
                                    <motion.button
                                        className="px-8 py-3.5 bg-white text-gray-900 font-medium rounded-full transition-all flex items-center space-x-2 group"
                                        whileHover={{
                                            scale: 1.03,
                                            boxShadow:
                                                "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
                                        }}
                                        whileTap={{ scale: 0.97 }}
                                    >
                                        <span>Discutons de votre projet</span>
                                        <motion.svg
                                            className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                                            />
                                        </motion.svg>
                                    </motion.button>
                                </Link>
                            </motion.div>
                        </div>
                        <div className="p-6 md:p-12 flex flex-col justify-between bg-white relative">
                            <div className="absolute inset-0 bg-[radial-gradient(circle_at_var(--mouse-x,50%)_var(--mouse-y,50%),rgba(99,102,241,0.1)_0%,transparent_50%)]"></div>
                            <div className="relative z-10">
                                <motion.h4
                                    className="text-2xl font-bold mb-2 text-gray-800"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.3 }}
                                >
                                    Bénéfices clés
                                </motion.h4>
                                <div className="space-y-3 mb-6">
                                    {activeService.benefits.map(
                                        (benefit, idx) => (
                                            <motion.div
                                                key={idx}
                                                initial={{ opacity: 0, x: -20 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{
                                                    delay: 0.4 + idx * 0.1,
                                                    type: "spring",
                                                    stiffness: 100,
                                                }}
                                                className="flex items-center"
                                            >
                                                <div
                                                    className={`bg-gradient-to-br w-8 h-8 rounded-full flex items-center justify-center text-white mr-4 flex-shrink-0 shadow-md ${
                                                        activeService
                                                            ? `${activeService.gradientColors}`
                                                            : ""
                                                    }`}
                                                >
                                                    <svg
                                                        className="w-4 h-4"
                                                        fill="currentColor"
                                                        viewBox="0 0 20 20"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                            clipRule="evenodd"
                                                        />
                                                    </svg>
                                                </div>
                                                <p className="text-gray-700 font-medium text-md">
                                                    {benefit}
                                                </p>
                                            </motion.div>
                                        )
                                    )}
                                </div>
                                <motion.h4
                                    className="text-2xl font-bold mb-2 text-gray-800"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.5 }}
                                >
                                    Résultats attendus
                                </motion.h4>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-6">
                                    {activeService.features.map(
                                        (feature, idx) => (
                                            <motion.div
                                                key={idx}
                                                initial={{ opacity: 0, y: 15 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{
                                                    delay: 0.6 + idx * 0.1,
                                                }}
                                                className="bg-gray-50 p-4 sm:p-5 rounded-xl hover:shadow-md transition-shadow border border-gray-100"
                                            >
                                                <div className="font-bold text-gray-800 mb-1">
                                                    {feature.value}
                                                </div>
                                                <div className="text-xs sm:text-sm font-medium text-gray-500">
                                                    {feature.name}
                                                </div>
                                                <div className="mt-2 text-xs text-gray-600">
                                                    {feature.description}
                                                </div>
                                            </motion.div>
                                        )
                                    )}
                                </div>
                            </div>
                            <motion.div
                                className="mt-2 pt-6 border-t border-gray-100"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.7 }}
                            >
                                <div className="flex flex-col space-y-6">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-110 hover:bg-gray-50 shadow-sm">
                                            <svg
                                                className="w-6 h-6 text-gray-500"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">
                                                Délai de livraison estimé
                                            </p>
                                            <p className="font-medium text-gray-800">
                                                {activeService.deliveryTime}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-110 hover:bg-gray-50 shadow-sm">
                                            <svg
                                                className="w-6 h-6 text-gray-500"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                                                />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">
                                                Livrables inclus
                                            </p>
                                            <p className="font-medium text-gray-800">
                                                {activeService.deliverables}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
